module.exports = __webpack_public_path__ + "media/images/emblems/Treycovagnes-coat_of_arms-cf63b0b276851dc7852a858a2d3054a0.svg";